import { render, staticRenderFns } from "./BasketFilter.vue?vue&type=template&id=d24bb91c&"
import script from "./BasketFilter.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasketFilter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BasketFilter.vue?vue&type=style&index=0&id=d24bb91c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports